import { parse, stringify } from 'qs';
import { f as _wrapRegExp, a as _assign } from './common.js';

/**
 * app인지 web인지 확인하고, app일 경우 추가로 app의 osType, osVersion도 확인합니다.
 * @param query query
 * @returns app이라면 isApp: true, osType, osVersion을 return. web이라면 isApp: false를 return.
 */
function getDeviceInfo(query) {
  var osType = null;
  var osVersion = null;
  if (typeof window === 'undefined') {
    if (query != null) {
      osType = query.os_type;
      osVersion = query.version;
    }
  } else {
    var search = parse(location.search.slice(1));
    if (search.os_type != null) {
      osType = search.os_type;
      sessionStorage.os_type = search.os_type;
    } else {
      osType = sessionStorage.os_type;
    }
    if (search.os_version != null) {
      osVersion = search.version;
      sessionStorage.os_version = search.version;
    } else {
      osVersion = sessionStorage.os_version;
    }
  }
  if (osVersion == null && osType == null) {
    return {
      isApp: false
    };
  } else {
    return {
      isApp: true,
      osType: osType,
      osVersion: osVersion
    };
  }
}
/**
 * params로 받은 AOS, iOS 버전보다 높은 버전의 app인지 확인합니다.
 * @param AOS 기준 AOS 버전
 * @param iOS 기준 iOS 버전
 * @param query query
 * @returns params로 받은 AOS, iOS 버전보다 높은 버전인 App일 경우 true. Web or MWeb or 기준보다 낮은 버전일 경우 false.
 */
function isHigherAppVersion(_a) {
  var AOS = _a.AOS,
    iOS = _a.iOS,
    query = _a.query;
  var _b = getDeviceInfo(query),
    isApp = _b.isApp,
    osType = _b.osType,
    osVersion = _b.osVersion;
  if (!isApp || !osType || !osVersion) return false;
  var targetSelected;
  if (osType === 'Android') {
    targetSelected = AOS;
  } else if (osType === 'iOS') {
    targetSelected = iOS;
  } else {
    return false;
  }
  var currentVersion = /^\d+(\.(\d+))+/.exec(osVersion);
  if (!currentVersion) {
    return false;
  }
  var targetFragments = targetSelected.split('.');
  var versionFragments = currentVersion[0].split('.');
  for (var i = 0; i < targetFragments.length; i += 1) {
    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt(versionFragments[i], 10);
    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }
  return false;
}

// e.g. https://prs.ohou.se/kr/any/examples/v1-141430605185088.jpg
// e.g. https://prs.ohouse.com/apne2/any/uploads/commerce/event/raffle/v1-175699276497024.png
var PRS_IMAGE_PATTERN = /*#__PURE__*/_wrapRegExp(/^(https?:\/\/(?:\w+\x2D)?prs\.(?:ohou\.se|ohouse\.com)\/[^?]+).*/, {
  src: 1
});
// e.g. https://image.ohou.se/i/{bucketplace-v2-development}/*
var IMAGE_OHOUSE_PATTERN = /*#__PURE__*/_wrapRegExp(/^(https?:\/\/(?:image\.ohou\.se\/i|(?:\w+\x2D)?image\.ohouse\.com)\/[^?]+).*/, {
  src: 1
});
// e.g. /oh-s3-video-{envPath}/*
// /oh-s3-video-apne2-stage-thumbnail/65685e94888fb53cb1f2e33c/65685e94888fb53cb1f2e33c.0000001.jpg
var VIDEO_THUMBNAIL_PATTERN = /*#__PURE__*/_wrapRegExp(/^(\/oh\x2Ds3\x2Dvideo[^?]+).*/, {
  path: 1
});
// e.g.
// https://image.ohou.se/image/central_crop/{bucketplace-v2-development}/*
// https://image.ohou.se/image/resize/{bucketplace-v2-development}/*
var IMAGE_OHOUSE_LEGACY_PATTERN = /*#__PURE__*/_wrapRegExp(/^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.*/, {
  bucket: 1,
  path: 2
});
// e.g. https://s3-{region}.amazonaws.com/{bucket}/{path}
var S3_LOCAL_PATTERN = /*#__PURE__*/_wrapRegExp(/^https?:\/\/s3\x2D(?:[^.]+)\.amazonaws.com\/([^?/]+)\/([^?]+).*/, {
  bucket: 1,
  path: 2
});
// e.g.
// https://{bucket}.cloudfront.net/*
// https://{bucket}.s3.amazonaws.com/*
// https://{bucket}.s3.{region}.amazonaws.com/{path}
var S3_LOCAL_PATTERN_2 = /*#__PURE__*/_wrapRegExp(/^https?:\/\/([^.]+)\.(?:cloudfront.net|s3\.(?:[^.]+\.)?amazonaws\.com)\/([^?]+)/, {
  bucket: 1,
  path: 2
});
var OLD_BUCKET_NAMES = ['d224jl0o7z9gbn', 'd12gkpu9h0k5iq'];
var NEW_BUCKET_NAME = 'bucketplace-v2-development';
var IMAGE_HOST = 'image.ohou.se';
var GLOBAL_IMAGE_HOST = 'image.ohouse.com';
var GLOBAL_QA_IMAGE_HOST = 'qa-image.ohouse.com';
var GLOBAL_BUCKET_LIST = ['video-service-prd-s3-bucket-thumbnail', 'oh-image-stage', 'oh-image-ap-northeast-2', 'oh-image-ap-southeast-1', 'oh-image-eu-central-1', 'oh-image-us-east-1', 'oh-image-us-west-2', 'oh-s3-video-qa-thumbnail'];
/**
 * @param imageOptions 이미지 옵션
 * @returns {string} 변환된 이미지 경로
 *
 * getImageUrl은 다음과 같은 규칙으로 이미지 경로를 변환합니다.
 * 1. prs를 사용하는 이미지 경로라면 imageOptions 만 query로 추가하여 반환합니다.
 * 2. 이미 이미지서버를 사용하고 있는 이미지 경로라면 imageOptions 만 query로 추가하여 반환합니다.
 * 3. 비디오 서버 썸네일에 해당하는 이미지 절대경로라면 국외향 이미지서버 url로 변환합니다.
 * 4. 이전 이미지 서버나 S3 버킷에 해당하는 이미지 경로라면 추출된 버킷에 따라 국내향 또는 국외향 이미지서버 url로 변환합니다.
 * 5. 위의 조건 중 어디에도 해당하지 않는다면 src를 그대로 반환합니다.
 */
function getImageUrl(imageOptions) {
  var src = imageOptions.src;
  if (src === '') {
    return src;
  }
  var optionQueries = buildCdnOptionsQuerystring(imageOptions);
  var extraQueries = extractQuerystring(src);
  var query = "?".concat(optionQueries, "&").concat(extraQueries).replace(/(&|\?|\?&)$/, '');
  var match;
  // Use PRS CDN if possible
  if (match = PRS_IMAGE_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var src_1 = match.groups.src;
    return "".concat(src_1).concat(query);
  }
  // Use src if it is already from image-server
  if (match = IMAGE_OHOUSE_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var src_2 = match.groups.src;
    return "".concat(src_2).concat(query);
  }
  // Use global image-server if it starts with '/oh-s3-video'
  if (match = VIDEO_THUMBNAIL_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var path = match.groups.path;
    var preProdEnv = ['dev', 'stage', 'qa'].find(function (env) {
      return src.includes(env);
    });
    if (preProdEnv != null) {
      return "https://".concat(preProdEnv, "-").concat(GLOBAL_IMAGE_HOST).concat(path).concat(query);
    }
    // prod 일 경우
    return "https://".concat(GLOBAL_IMAGE_HOST).concat(path).concat(query);
  }
  // Convert to image-server if it is legacy image server url or s3 bucket url
  if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _a = match.groups,
      bucket = _a.bucket,
      path = _a.path;
    return "https://".concat(IMAGE_HOST, "/i/").concat(bucket, "/").concat(path.replace(/-/g, '/')).concat(query);
  } else if (match = S3_LOCAL_PATTERN.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _b = match.groups,
      bucket = _b.bucket,
      path = _b.path;
    var bucketName = OLD_BUCKET_NAMES.includes(bucket) ? NEW_BUCKET_NAME : bucket;
    var isDomestic = bucketName === NEW_BUCKET_NAME;
    var host = isDomestic ? "".concat(IMAGE_HOST, "/i") : GLOBAL_IMAGE_HOST;
    return "https://".concat(host, "/").concat(bucketName, "/").concat(path).concat(query);
  } else if (match = S3_LOCAL_PATTERN_2.exec(src), (match === null || match === void 0 ? void 0 : match.groups) != null) {
    var _c = match.groups,
      bucket = _c.bucket,
      path = _c.path;
    var bucketName = OLD_BUCKET_NAMES.includes(bucket) ? NEW_BUCKET_NAME : bucket;
    var isDomestic_1 = !GLOBAL_BUCKET_LIST.includes(bucketName);
    var isQA_1 = bucketName.includes('qa');
    var host = function () {
      if (isDomestic_1) return "".concat(IMAGE_HOST, "/i");
      if (isQA_1) return GLOBAL_QA_IMAGE_HOST;
      return GLOBAL_IMAGE_HOST;
    }();
    return "https://".concat(host, "/").concat(bucketName, "/").concat(path).concat(query);
  }
  return src;
}
function buildCdnOptionsQuerystring(_a) {
  var width = _a.width,
    height = _a.height,
    mode = _a.mode,
    quality = _a.quality;
  var query = {};
  if (width != null) query.w = String(width);
  if (height != null) query.h = String(height);
  if (mode != null) query.c = String(mode[0]);
  if (quality != null) query.q = String(quality);
  return stringify(query);
}
function extractQuerystring(src) {
  var match = src.match(/\?(.+)/);
  return match ? match[1] : '';
}

var getImageSrcSet = function getImageSrcSet(imageOptions, ratios) {
  return ratios.map(function (ratio) {
    return "".concat(getImageUrl(_assign(_assign(_assign({}, imageOptions), imageOptions.width && {
      width: imageOptions.width * ratio
    }), imageOptions.height && {
      height: imageOptions.height * ratio
    })), " ").concat(ratio, "x");
  }).join(',');
};

var IMAGE_SIZES = [36, 72, 144, 180, 256, 360, 480, 512, 640, 720, 850, 960, 1024, 1280, 1360, 1440, 1536, 1700, 1920, 2048, 2560];
function getNearestSize(originSize) {
  var _a;
  return (_a = IMAGE_SIZES.find(function (size) {
    return size >= originSize;
  })) !== null && _a !== void 0 ? _a : IMAGE_SIZES[IMAGE_SIZES.length - 1];
}

var calcImageSize = function calcImageSize(_a) {
  var width = _a.width,
    height = _a.height,
    aspect = _a.aspect;
  if (height) {
    var nearestHeight = getNearestSize(height);
    return _assign({
      height: nearestHeight
    }, aspect && {
      width: Math.ceil(nearestHeight * aspect)
    });
  }
  var nearestWidth = getNearestSize(width);
  return _assign({
    width: nearestWidth
  }, aspect && {
    height: Math.ceil(nearestWidth / aspect)
  });
};

var APP_BANNER_PATHNAME_BLACKLIST = /^\/normal_users|^\/sessions|^\/orders|^\/contacts|^\/exhibitions|^\/cart|^\/3d_intro|^\/interior3ds|^\/payment_personal_info/;
var APP_BANNER_SEARCH_BLACKLIST = /utm_source=(naver_shop|kakao_shop)|no_app_banner=true/;

export { APP_BANNER_PATHNAME_BLACKLIST as A, getImageUrl as a, getImageSrcSet as b, getNearestSize as c, calcImageSize as d, APP_BANNER_SEARCH_BLACKLIST as e, getDeviceInfo as g, isHigherAppVersion as i };
//# sourceMappingURL=utils.js.map
